module.exports = __webpack_public_path__ + "img/certNewImg.97e69e91.png";